import React from 'react';

import Footer from '../../components/Footer/Footer';
import Copyright from '../../components/Copyright/Copyright';

import styles from './FooterWithCopyright.module.css';

const FooterWithCopyright = () => {
  return (
    <div className={[styles.FooterContainer]}>
      <Footer />
      <Copyright />
    </div>
  );
};

export default FooterWithCopyright;
